import { Component, inject, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AnnouncementService } from './announcement.service';

/**
 * Shows the current announcements as full-width strips directly below the navigation, placed
 * right after it in each app's template. It stays in view while the page scrolls, and pushes the
 * page content down rather than covering it.
 *
 * Where the navigation is fixed over the page (the home pages of culturequestion and
 * ciprofile), `fixedTop` gives the navigation's height: the banner is then fixed below it,
 * over the top of the page.
 */
@Component({
  selector: 'multisite-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrl: './announcement-banner.component.scss',
  imports: [TranslocoDirective, TooltipModule],
  host: {
    '[class.fixed]': 'fixedTop() !== null',
    '[style.top]': 'fixedTop()',
  },
})
export class AnnouncementBannerComponent {
  readonly announcementService = inject(AnnouncementService);

  /** The height of a fixed navigation to stay below, as a CSS length; null where it is in the page. */
  readonly fixedTop = input<string | null>(null);
}
